import { isEmpty } from "lodash-es";
import React, { FC, memo, useState } from "react";
import { useTranslation } from "react-i18next";

import { Button } from "@/components/Button";
import { FloatedList } from "@/eworkitComponents";
import { useCut } from "@/hooks/Array";

import { SkillLevel } from "./SkillLevel";

export interface ISkillsListProps {
  list: any[];
  getKey: (value: any) => string;
  getText: (value: any) => string;
  getLevelText?: (value: any) => string;
  showMore?: boolean;
  visibleSkillsCount?: number;
  clickable?: boolean;
}

export const DEFAULT_VISIBLE_SKILLS_COUNT = 3;

export const SkillsList: FC<ISkillsListProps> = memo(
  ({ children, getKey, getText, getLevelText, list, showMore = false, visibleSkillsCount, clickable = true }) => {
    const [visibleSkills, hiddenSkills] = useCut(list, visibleSkillsCount);
    const [shown, setShown] = useState(false);
    const { t } = useTranslation(["session"]);
    const shouldDisplayShowMore = showMore && !isEmpty(hiddenSkills);

    if (isEmpty(list) && !children) {
      return null;
    }

    const renderShowMore = (hidden: number) => (
      <SkillLevel
        color="secondary"
        round
        mono={false}
        size="md"
        text={`+${hidden} ${t("session:JOB_REQUESTS.DETAIL.MORE_SKILLS")}`}
      />
    );

    return (
      <div>
        <FloatedList size="sm">
          {visibleSkills.map(s => (
            <SkillLevel
              key={getKey(s)}
              color="secondary"
              round
              mono={false}
              size="md"
              text={getText(s)}
              levelText={getLevelText && getLevelText(s)}
            />
          ))}
          {shouldDisplayShowMore &&
            (shown ? (
              hiddenSkills.map(s => (
                <SkillLevel
                  key={getKey(s)}
                  color="secondary"
                  round
                  mono={false}
                  size="md"
                  text={getText(s)}
                  levelText={getLevelText && getLevelText(s)}
                />
              ))
            ) : clickable ? (
              <Button onClick={() => setShown(true)} variant="link">
                {renderShowMore(hiddenSkills.length)}
              </Button>
            ) : (
              renderShowMore(hiddenSkills.length)
            ))}
          {children}
        </FloatedList>
      </div>
    );
  },
);
